import React from 'react';
import { render, unmountComponentAtNode } from 'react-dom';

import tr from '../../../localization/translate';

import IggloProgressBar from '../../../common/IggloProgressBar';

import s from './CircleOverlay.scss';

export default function CircleOverlayCreator() {
  const spherical = global.google.maps.geometry.spherical;

  return class CircleOverlay extends global.google.maps.OverlayView {
    constructor(props) {
      super();
      this.props = props;

      this.containerAttrs = {
        containerTop: 0,
        containerLeft: 0,
        containerWidth: 0,
        containerHeight: 0
      };
    }

    setProps(nextProps) {
      this.props = nextProps;

      if (this.node) {
        this.draw();
      }
    }

    updateBounds() {
      const projection = this.getProjection();

      const nc = projection.fromLatLngToDivPixel(
        spherical.computeOffset(this.props.center, this.props.radius, 0));
      const wc = projection.fromLatLngToDivPixel(
        spherical.computeOffset(this.props.center, this.props.radius, 270));

      this.containerAttrs = {
        containerTop: nc.y,
        containerLeft: wc.x,
        containerWidth: (nc.x - wc.x) * 2,
        containerHeight: (nc.y - wc.y) * 2
      };
    }

    onAdd() {
      this.node = document.createElement('div');
      this.node.style.position = 'absolute';
      this.node.style.top = '0';
      this.node.style.right = '0';
      this.node.style.left = '0';
      this.node.style.bottom = '0';

      this.getPanes().overlayLayer.appendChild(this.node);
    }

    onRemove() {
      unmountComponentAtNode(this.node);
      this.node.parentNode.removeChild(this.node);
      this.node = null;
    }

    draw() {
      this.updateBounds();
      this.renderToNode();
    }

    renderToNode() {
      render((
        <IggloProgressBar
          childContainerClassName={s.content}
          style={{
            position: 'absolute',
            top: `${this.containerAttrs.containerTop}px`,
            left: `${this.containerAttrs.containerLeft}px`,
            width: `${this.containerAttrs.containerWidth}px`,
            height: `${this.containerAttrs.containerHeight}px`
          }}
          duration={380}
          strokeWidth={5}
          trailWidth={8}
          progress={this.props.progress}
          initialAnimate
        >
          <>
            <i styleName="indicator_line" />
            <p className="effra rem_1_25 white" styleName="text">
              { tr('matching.matching_percentage_breakout.radius', { count: this.props.radius }) }
            </p>
          </>
        </IggloProgressBar>
      ), this.node);
    }
  };
}
